module.exports = __webpack_public_path__ + "static/media/ic-eletricidade.6539aa4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Svg/ic-eletricidade.svg
// module id = 431
// module chunks = 0